var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Loading',{staticClass:"global-loading",attrs:{"status":_vm.isLoading,"opacity":1,"linear":_vm.isLoading=='linear',"color":"grey","size":50,"width":2}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }